import React from "react";
import {Button} from "@chakra-ui/react";
import {foundationIsDark} from "../../theme/utils";
import {lighten, darken} from "@chakra-ui/theme-tools";
import theme from "../../theme";


/**
 * Wrapper component for Chakra's Button component to allow dynamic background color.
 * Valid props:
 *  - buttonColor
 *
 *  All other props are passed to the Button component.
 */
export const ColorButton = (props) => {
    const {
        buttonColor,
        children,
        ...rest
    } = props;

    // Default to the AnvilTheme primary color.
    let color = buttonColor !== undefined && buttonColor.length > 0 ? buttonColor : "primary.500"

    const dark = foundationIsDark(theme, color)
    const hoverColor = dark ? lighten(color, 10) : darken(color, 10)
    const textColor = dark ? "white" : "black"


    return <Button
        borderColor="cardBorder"
        borderWidth= {2}
        textColor={textColor}
        borderStyle={dark ? "none" : "solid"}
        bg={color}
        _hover={{bg: hoverColor, color: textColor}}
        _active={{bg: hoverColor, color: textColor}}
        {...rest}
    >
        {children}
    </Button>;
};
